import "./IconEquals.scss";

export const IconEquals = () => {
  return <span className="IconEquals"></span>;
};
